import { checkIsValidPeriod } from "./private/checkIsValidPeriod";
import { checkIsMovable } from "./private/checkIsMovable";

// 譲渡ボタンを表示するかどうか
export const checkIsTransferable = (masterBook, book) => {
  return (
    masterBook.transferable &&
    !book.is_valid &&
    checkIsValidPeriod(book) && checkIsMovable(book) &&
    (book.transfer_status == "transferable" || book.transfer_status == "transferring")
  );
}